/* global $ */

import { getAllProgrammes } from "@/data/programmes_info";

export default {
  name: "ProgrammesComponent",

  props: {
    main_label: {
      type: String,
      required: true
    },
    active_programme_id: ({
      type: [String, Number, null],
      default: null
    }),
    open: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ""
    }
  },

  emits: ["toggle", "open-programme"],

  data() {
    return ({
      programmes: []
    });
  },

  mounted() {
    this.programmes = getAllProgrammes();
    this.bindOutsideClick();
  },

  beforeUnmount() {
    $(document).off("click.programmes-component");
  },

  methods: {
    toggle() {
      this.$emit("toggle");
    },

    isActiveProgramme(programme) {
      return programme?.id === this.active_programme_id;
    },

    navigateToProgramme(programme) {
      this.$emit("open-programme", programme);
      this.$emit("toggle");
    },

    bindOutsideClick() {
      $(document).on("click.programmes-component", (e) => {
        const dropdown = this.$el.querySelector(".context-dropdown");
        const toggle = this.$el.querySelector(".context-card");

        if (!this.open) return;

        if (!dropdown?.contains(e.target) && !toggle?.contains(e.target)) {
          this.$emit("toggle");
        }
      });
    }
  }
};
